import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export default function TafseerCourseTeacher() {
  return (
    <section className="my-48">
      <div className="my-10 flex flex-col md:flex-row items-center md:items-start">
        <div className="justify-center">
          <p className="bg-green-100 p-5 rounded">
            <FontAwesomeIcon
              className="text-4xl text-green-600"
              icon={faUser}
            />
          </p>
        </div>
        <div className="px-2">
          <p className="font-bold ">কোর্স প্রণেতাঃ</p>
          <p className="text-xl text-green-600">
            শায়খ আব্দুল্লাহ আল কাফী মাদানী (রহি.)
          </p>
          <p>
            দাঈ, ইসলামী দাওয়াহ এন্ড গাইডেন্স সেন্টার, দক্ষিণ জেদ্দা, সৌদি আরব।
          </p>
        </div>
      </div>
      <div className=" my-10 flex flex-col md:flex-row items-center md:items-start">
        <div className="justify-center">
          <p className="bg-blue-100 p-5 rounded">
            <FontAwesomeIcon className="text-4xl text-blue-600" icon={faUser} />
          </p>
        </div>
        <div className="px-2">
          <p className="font-bold ">কোর্স পরিচালনা ও সার্বিক তত্ত্বাবধানঃ</p>
          <p className="text-xl text-blue-600">
            শায়খ আব্দুল্লাহ আল বাকি (হাফি.)
          </p>
          <p>পরিচালক, আল হারামাইন ইসলামী একাডেমি।</p>
          <p>
            দাঈ, ইসলামী দাওয়াহ এন্ড গাইডেন্স সেন্টার, পূর্ব জেদ্দা, সৌদি আরব।
          </p>
        </div>
      </div>
    </section>
  );
}
